module.exports = __webpack_public_path__ + "static/media/p4preview.5222b149.png";